import React from "react"

import { IgrLinearGauge } from 'igniteui-react-gauges';
import { IgrLinearGraphRange } from 'igniteui-react-gauges';


export default function CustomGauge(props) {
  let finished_avs = 0
  let malwares_count = 0
  let percent = 0
  let value = 0

  if (Object.values(props.data.progress).length > 0) {
    Object.keys(props.data.progress).map((data, index) => {
      if (props.data.progress[data] === 100)
        finished_avs += 1
    })
    if (props.data.malware) {
      Object.values(props.data.malware.normal).map((data, index) => { // normal files
        data.forEach((res) => {
          malwares_count += 1
        })
        percent = (malwares_count / finished_avs) * 100
        if(percent <= 5)
        value = percent * 5
        else if(percent > 5 && percent <= 10)
        value = 25 + (percent - 5) * 5
        else if(percent > 10 && percent <= 15)
        value = 50 + (percent - 10) * 5
        else
        value = 75 + (percent - 15) * 25 / 85
      })
    }
  }

  return (
    <IgrLinearGauge
      height="30px"
      width="100%"
      labelExtent={0.0}
      labelFormat=""
      labelInterval={10}
      minimumValue={0} value={value}
      maximumValue={100} interval={25} backingBrush='transparent' backingOutline="transparent"
      rangeBrushes="#80CBC4, #FFF176,#FFA726,#FF5722"
      rangeOutlines="#80CBC4, #FFF176,#FFA726,#FF5722"  >
      <IgrLinearGraphRange name="range1"
        width={'100%'}
        height='100%'
        startValue={0} endValue={25}
        innerStartExtent={-1} innerEndExtent={-1}
        outerStartExtent={.7} outerEndExtent={.7} />
      <IgrLinearGraphRange name="range2"
        startValue={25} endValue={50}
        innerStartExtent={-1} innerEndExtent={-1}
        outerStartExtent={.7} outerEndExtent={.7} />
      <IgrLinearGraphRange name="range3"
        startValue={50} endValue={75}
        innerStartExtent={-1} innerEndExtent={-1}
        outerStartExtent={.7} outerEndExtent={.7} />
      <IgrLinearGraphRange name="range4"
        startValue={75} endValue={100}
        innerStartExtent={-1} innerEndExtent={-1}
        outerStartExtent={.7} outerEndExtent={.7} />
    </IgrLinearGauge>
  )
}